import React, { useState } from 'react';
import PhysicsLayout from './PhysicsLayout';

const HeatBench = () => {
  const [k, setK] = useState(160);
  const [A, setA] = useState(25);
  const [L, setL] = useState(4);
  const [dT, setDT] = useState(40);
  const area = A / 1e4;
  const thick = L / 1000;
  const q = (k * area * dT) / thick;
  const r = thick / (k * area);

  return (
    <PhysicsLayout
      kicker="Bench 6 · every thermal stack"
      title="Heat path"
      lead="Conduction through a slab: q = k A ΔT / L. This is a TIM, a heat spreader, a furnace wall, a die-to-lid path. Units in watts, not vibes."
    >
      <div className="pp-split">
        <div>
          <label className="pp-field">k {k} W/m·K
            <input type="range" min="0.2" max="400" step="0.2" value={k} onChange={(e) => setK(+e.target.value)} />
          </label>
          <label className="pp-field">Area {A} cm²
            <input type="range" min="1" max="80" value={A} onChange={(e) => setA(+e.target.value)} />
          </label>
          <label className="pp-field">Thickness {L.toFixed(1)} mm
            <input type="range" min="0.2" max="20" step="0.1" value={L} onChange={(e) => setL(+e.target.value)} />
          </label>
          <label className="pp-field">ΔT {dT} K
            <input type="range" min="1" max="120" value={dT} onChange={(e) => setDT(+e.target.value)} />
          </label>
        </div>
        <div className="pp-readout">
          <p className="pp-eq">q = kAΔT / L · R = L / (kA)</p>
          <strong>{q.toFixed(1)} W</strong>
          <p className="pp-note">
            Thermal resistance { (r * 1000).toFixed(2) } K/W. Copper (~400) vs epoxy (~0.3) is why a TIM exists.
            If you need more watts out, you buy area, conductivity, or you shorten the path — you do not wish.
          </p>
        </div>
      </div>
    </PhysicsLayout>
  );
};

export default HeatBench;
